import { calculatorConstants } from '../../constants'

const setCurrentVal = values => dispatch => {
    dispatch({ type: calculatorConstants.CURRENTVAL, payload: { ...values } })
}

export const calculatorCreators = {
    setCurrentVal,
}
